module.exports = __webpack_public_path__ + "img/tab-default.e3443cde.png";